import { Controller, useFormContext } from 'react-hook-form'

import { FF2, USPhoneInput } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const PhoneNumber = ({ index1, index2 }: { index1: number; index2: number }) => {
  const { control } = useFormContext<SarEdit>()

  return (
    <Controller
      name={`subjectsInfo.${index1 as 0}.phoneNumbers.${index2 as 0}.phoneNumber`}
      control={control}
      render={({ field }) => (
        <FF2 field={field} label="21. Phone number" input={(props) => <USPhoneInput {...props} />} />
      )}
    />
  )
}
